import React, { useState, useEffect } from "react";
import d from "./detail.module.css";
import { getVideogame } from "../../redux/actions/index";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import Loader from "../loader/loader";
import star from "../../assets/icons_starFav.png";
import ico_nintendo from "../../assets/ico_nintendo.png";
import ico_xbox from "../../assets/ico_xbox.png";
import ico_playstation from "../../assets/ico_playstation.png";
import ico_pc from "../../assets/ico_pc.png";
import ico_mac from "../../assets/ico_mac.png";
import ImageSlider from "../slider/slider";
import { SliderData } from "../slider/sliderData";

export default function Detail() {
  //

  const { id } = useParams();
  const details = useSelector((state) => state.videogame);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getVideogame(id)).then(() => setCarga(false));
  }, [dispatch, id]);

  const [carga, setCarga] = useState(true);
  if (carga) {
    return <Loader />;
  }

  //Mostrar generos en texto

  let formatGenre;

  if (isNaN(Number(id))) {
    formatGenre = details.genres?.map((e, i) => {
      if (i === details.genres.length - 1) {
        return e.name;
      }
      return `${e.name} / `;
    });
  } else {
    formatGenre = details.genres?.map((e, i) => {
      if (i === details.genres.length - 1) {
        return e;
      }
      return `${e} / `;
    });
  }

  //Mostrar plataformas en texto

  // const formatPlatforms = detalle.platforms?.map((e, i) => {
  //   if (i === detalle.platforms.length - 1) {
  //     return e;
  //   }
  //   return `${e} - `;
  // });

  // logica para mostrar logos de plataformas y que no se repitan
  const iconPlatform = {
    Nintendo: ico_nintendo,
    Xbox: ico_xbox,
    PlayStation: ico_playstation,
    PC: ico_pc,
    macOS: ico_mac,
  };

  const platform = details.platforms?.map((e) => e);
  let noRepeat = [];

  if (platform) {
    for (let i = 0; i < platform.length; i++) {
      platform[i] = platform[i].split(" ");

      if (iconPlatform[platform[i][0]]) {
        noRepeat.push(platform[i][0]);
      }
    }

    noRepeat = [...new Set(noRepeat)];
  }
  //

  return (
    <div className={d.details}>
      {details && (
        <>
          <div className={d.imgBack}>
            <img
              src={details.image2 ? details.image2 : details.image}
              alt="game2"
            />
            <div className={d.gradBack}></div>
          </div>
          <ImageSlider slides={SliderData} />
          <Link to="/home" className={d.btnBack}></Link>
          <span className={d.tituloDetails}>
            <h2>Game details</h2>
          </span>
          <div className={d.row}>
            <div className={d.tituloGame}>
              <h2>{details.name}</h2>
            </div>
          </div>
          <br></br>
          <div className={d.row2}>
            <div className={d.descText}>
              <p>{details.description}</p>
            </div>
            <div className={d.frame}>
              <div className={d.wrapperImg}>
                <img src={details.image} alt="game" />
              </div>
              <div className={d.detailGames}>
                <p>Release date: {details.released}</p>
                <p>Genres:</p>
                <p>{formatGenre}</p>
                <div className={d.divIcons}>
                  <p>{details.rating}</p>
                  <img className={d.icoRating} src={star} alt="Star" />
                </div>
                <div className={d.divIcons}>
                  {noRepeat.map((e, i) => (
                    <div className={d.icoPlatform} key={i}>
                      <img src={iconPlatform[e]} alt="icon" />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}
